import $ from 'jquery';

import header from '../../../views/partials/header/header';
import hamburger from '../../../views/partials/hamburger/hamburger';
import slider_homepage from '../../../views/blocks/slider-homepage/slider-homepage';
import slider_header from '../../../views/blocks/slider-header/slider-header';
import titolo_testo_bottone_immagine_due from '../../../views/blocks/titolo-testo-bottone-immagine-due/titolo-testo-bottone-immagine-due';
import gallery from '../../../views/blocks/gallery/gallery';
import cambio_background from '../../../views/blocks/cambio-background/cambio-background';
import tre_blocchi from '../../../views/blocks/tre-blocchi/tre-blocchi';
import tre_blocchi from '../../../views/blocks/faqs/faqs';
import video from '../../../views/blocks/video/video';

export default {
    init() {
    },

    finalize() {
        header();
        hamburger();
    },
};


// WEBPACK FOOTER //
// ./scripts/routes/common.js